import { ComponentPropsWithoutRef, useState } from 'react';

import { Row } from '@tanstack/react-table';
import {
  EventRule,
  EventRuleStatuses,
} from '@/features/event-rules/schemas/event-rules.schema.ts';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { EditIcon } from 'lucide-react';
import { LoaderIcon } from '@/assets/loader-icon.tsx';
import { usePatchEventRulesMutation } from '@/features/event-rules/hooks/mutations/use-patch-event-rules.ts';

interface DeleteEventRulesDialogProps extends ComponentPropsWithoutRef<typeof DropdownMenu> {
  eventRules: Row<EventRule>['original'][];
  onSuccess?: () => void;
  showTrigger?: boolean;
}

export function EventRulesTableToolbarEditDropdown({
  eventRules,
  onSuccess,
}: DeleteEventRulesDialogProps) {
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  const isLoading = false;

  const { mutate } = usePatchEventRulesMutation({
    onSuccess: () => {
      onSuccess?.();
      setIsDropdownMenuOpen(false);
    },
  });

  const onSubmit = (status: EventRuleStatuses) => {
    mutate(
      eventRules.map(({ eventRuleId }) => ({
        eventRuleId,
        status,
      }))
    );
  };

  return (
    <DropdownMenu open={isDropdownMenuOpen} onOpenChange={setIsDropdownMenuOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex w-min gap-2">
          {isLoading ? (
            <LoaderIcon className="size-3.5 animate-spin" />
          ) : (
            <>
              <EditIcon className="size-4" aria-hidden="true" />
              <span className="hidden sm:inline-block">Edit ({eventRules.length})</span>
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>Status</DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuItem
                onClick={() => {
                  onSubmit('enabled');
                }}
              >
                Enabled
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  onSubmit('disabled');
                }}
              >
                Disabled
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
        {/*<DropdownMenuItem>Edit</DropdownMenuItem>*/}
        {/*<DropdownMenuItem>Delete</DropdownMenuItem>*/}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default EventRulesTableToolbarEditDropdown;
